// extracted by mini-css-extract-plugin
module.exports = {"phones":"aee5b7c44e--phones--8dtfA","phones-animation":"aee5b7c44e--phones-animation--SU1c9","to-open-phones-animation":"aee5b7c44e--to-open-phones-animation--otn5R"};